const getModifiedString = (originalString: string) => originalString.toLowerCase().replace(/\s/g, '');

export const getIsSubstring = (originalString: string, searchedString: string) => {
  const modifiedOriginalString = getModifiedString(originalString);
  const modifiedSearchedString = getModifiedString(searchedString);

  return modifiedOriginalString.includes(modifiedSearchedString);
};
